<template lang="pug">
#register
  .container
    #accordion.mb-5.mt-3
      .row
        .col.text-center
          img(src="@/assets/img/icons/send.svg")
          h4 您差一步就完成報名動作嚕！
          p.red(@click="toLine", style="cursor: pointer") 1.請按此加入TOP巔峰 Line官方帳號與線上客服聯絡，確認繳費及優惠資訊
          p 2.或是撥打(02)2935-6123與客服專員聯絡
          p 3.亦或是耐心等待客服人員與您聯絡喔!

    .row.submit-btn.mt-3.justify-content-center
      .col-md-12.text-center
        .send_btn(@click="toHome") 前往我的訂單
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";

export default {
  name: "EnrollComplete",
  components: {
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      email: "",
      password: "",
      passwordRepeat: "",
    };
  },
  methods: {
    toHome() {
      this.$router.push({ name: "MemberCenter" });
    },
    toLine() {
      window.open("https://line.me/R/ti/p/%40topbasketball");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/enroll/complete";
</style>
